import request from '@/api/request.js';

// 题库管理

// 项目列表 

export const projectPage = (data) => {
  return request({
    url: '/product/adm/project/page',
    method: 'post',
    type: 'json',
    data
  })
}

// ---------分类管理---------

// 习题分类列表
export const examClassificationPage = (data) => {
  return request({
    url: '/exam/adm/examClassification/page',
    method: 'post',
    type: 'json',
    data
  })
}

//习题分类 - 添加  
export const examClassificationAdd = (data) => {
  return request({
    url: '/exam/adm/examClassification/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 习题分类 - 删除 
export const examClassificationDel = (data) => {
  return request({
    url: '/exam/adm/examClassification/del',
    method: 'post',
    type: 'json',
    data
  })
}

// 习题分类 - 更新  /exam/adm/examClassification/update

export const examClassificationUpdate = (data) => {
  return request({
    url: '/exam/adm/examClassification/update',
    method: 'post',
    type: 'json',
    data
  })
}

// 根据id获取习题分类  
export const examClassificationGet = (data) => {
  return request({
    url: '/exam/adm/examClassification/get',
    method: 'post',
    type: 'json',
    data
  })
}

// ---------分类管理end---------

// -------题目管理--------

// 分页查询题目列表
export const examTopicPage = (data) => {
  return request({
    url: '/exam/adm/examTopic/page',
    method: 'post',
    type: 'json',
    data
  })
}

// 添加题目 
export const examTopicAdd = (data) => {
  return request({
    url: '/exam/adm/examTopic/add',
    method: 'post',
    type: 'json',
    data
  })
}

//删除题目  
export const examTopicDel = (data) => {
  return request({
    url: '/exam/adm/examTopic/del',
    method: 'post',
    type: 'json',
    data
  })
}

// 根据id获取题目 
export const examTopicGet = (data) => {
  return request({
    url: '/exam/adm/examTopic/get',
    method: 'post',
    type: 'json',
    data
  })
}

// 更新题目 
export const examTopicUpdate = (data) => {
  return request({
    url: '/exam/adm/examTopic/update',
    method: 'post',
    type: 'json',
    data
  })
}

// 添加选项 
export const examOptionAdd = (data) => {
  return request({
    url: '/exam/adm/examOption/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 删除选项 
export const examOptionDel = (data) => {
  return request({
    url: '/exam/adm/examOption/del',
    method: 'post',
    type: 'json',
    data
  })
}

// 更新选项 
export const examOptionUpdate = (data) => {
  return request({
    url: '/exam/adm/examOption/update',
    method: 'post',
    type: 'json',
    data
  })
}

// 查询选项列表 
export const examOptionList = (data) => {
  return request({
    url: '/exam/adm/examOption/list',
    method: 'post',
    type: 'json',
    data
  })
}


// ---------试卷---------
// 添加试卷
export const examPaperAdd = (data) => {
  return request({
    url: '/exam/adm/examPaper/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 删除试卷 
export const examPaperDel = (data) => {
  return request({
    url: '/exam/adm/examPaper/del',
    method: 'post',
    type: 'json',
    data
  })
}

// 根据id获取试卷 
export const examPaperGet = (data) => {
  return request({
    url: '/exam/adm/examPaper/get',
    method: 'post',
    type: 'json',
    data
  })
}

// 分页查询试卷列表 
export const examPaperPage = (data) => {
  return request({
    url: '/exam/adm/examPaper/page',
    method: 'post',
    type: 'json',
    data
  })
}

// 更新试卷 
export const examPaperUpdate = (data) => {
  return request({
    url: '/exam/adm/examPaper/update',
    method: 'post',
    type: 'json',
    data
  })
}


// 分页查询 试卷的题目列表 或者 题目关联的试卷列表 
export const examPaperTopicPage = (data) => {
  return request({
    url: '/exam/adm/examPaperTopic/page',
    method: 'post',
    type: 'json',
    data
  })
}


// 批量添加试卷题目  
export const examPaperTopicAdds = (data) => {
  return request({
    url: '/exam/adm/examPaperTopic/adds',
    method: 'post',
    type: 'json',
    data
  })
}

// 批量删除试卷题目关联 
export const examPaperTopicDels = (data) => {
  return request({
    url: '/exam/adm/examPaperTopic/dels',
    method: 'post',
    type: 'json',
    data
  })
}

// ---------试卷end---------

// 导出试卷题目  
export const exportExamPaperTopic = (data) => {
  return request({
    url: '/exam/adm/examPaperTopic/exportExamPaperTopic',
    method: 'get',
    params:data
  })
}